import { z } from "astro/zod";

export const CAM_REF = "1100l3Td8E"; // to production env

export function buildExpediaHotelSearchLink(
  options: z.input<typeof hotelSearchSchema>,
) {
  const parsedOptions = hotelSearchSchema.parse(options);

  const url = new URL("https://www.expedia.com/affiliate");

  const targetURL = new URL("https://www.expedia.com/Hotel-Search");
  targetURL.search = new URLSearchParams(parsedOptions).toString();

  url.search = new URLSearchParams({
    landingPage: targetURL.toString(),
    camref: CAM_REF,
  }).toString();

  return url.href;
}

const hotelSearchSchema = z.object({
  adults: z.string().default("2"),

  children: z.string().default("0"),

  // Check-in date (YYYY-MM-DD format)
  d1: z.string().default(currentDate()),
  // Check-out date (YYYY-MM-DD format)
  d2: z.string().default(tommorowDate()),

  destination: z.string(),

  startDate: z.string().default(currentDate()),
  endDate: z.string().default(tommorowDate()),

  flexibility: z.string().default("0_DAY"),

  sort: z.string().default("RECOMMENDED"),
});

function currentDate() {
  return new Date().toISOString().split("T")[0];
}

function tommorowDate() {
  const today = new Date();
  const tomorrow = new Date(today);

  // Add one day to the date
  tomorrow.setDate(today.getDate() + 1);

  return tomorrow.toISOString().split("T")[0];
}

export function ExpediaWidget() {
  return (
    <>
      <div
        className="eg-widget eg-search-widget p-2 w-full"
        data-widget="search"
        data-program="us-expedia"
        data-lobs="stays,flights"
        data-network="pz"
        data-camref={CAM_REF}
      >
        <iframe
          className="eg-widget-frame eg-search-widget-frame w-full max-w-[450px] border-none m-auto h-[297.109px]"
          src={`https://affiliates.expediagroup.com/products/widgets/search-widget?program=us-expedia&lobs=stays,flights&network=pz&camref=${CAM_REF}`}
        ></iframe>
      </div>
    </>
  );
}

export function buildExpediaApartmentSearchLink(
  options: z.input<typeof vrboSearchSchema>,
) {
  const parsedOptions = vrboSearchSchema.parse(options);

  const url = new URL("https://www.vrbo.com/affiliate");

  const targetURL = new URL("https://www.vrbo.com/en-gb/search");
  targetURL.search = new URLSearchParams(parsedOptions).toString();

  url.search = new URLSearchParams({
    landingPage: targetURL.toString(),
    camref: CAM_REF,
  }).toString();

  return url.href;
}

const vrboSearchSchema = z.object({
  adults: z.string().default("2"),

  children: z.string().default("0"),

  destination: z.string(),

  sort: z.string().default("RECOMMENDED"),
});
